import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import cs from './locales/cs.json'
import en from './locales/en.json'
import uk from './locales/uk.json'

export const DEFAULT_LANGUAGE = 'uk'

void i18n.use(initReactI18next).init({
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: { escapeValue: false },
  lng: DEFAULT_LANGUAGE,
  resources: {
    cs: { translation: cs },
    en: { translation: en },
    uk: { translation: uk },
  },
})

i18n.on('languageChanged', (language) => {
  document.documentElement.lang = language
})

export default i18n
